import { render, staticRenderFns } from "./RatesNew.vue?vue&type=template&id=571dec6e&scoped=true"
import script from "./RatesNew.vue?vue&type=script&lang=js"
export * from "./RatesNew.vue?vue&type=script&lang=js"
import style0 from "./RatesNew.vue?vue&type=style&index=0&id=571dec6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dec6e",
  null
  
)

export default component.exports